import React from 'react'
import "./Social.css"
const Social = () => {
    return (
        <div className="social">
            <div className="social__links">
                <p>GitHub</p>
                <p>Linkedin</p>
                <p>Blogspace</p>
            </div>
        </div>
    )
}

export default Social
